import React from "react";
import { Text, StyleSheet } from "react-native";
import {styleVars} from "../../../app-style-vars";

export default function PtText(props) {

  /** calculate default styles */

  const defaultFontSize = () => {
    return (props.isTitle || props.headline ? styleVars.rem(1.5) : styleVars.rem(1));
  };

  const defaultFontWeight = () => {
    return (props.isTitle || props.headline ? 'bold' : 'normal');
  };

  const defaultBottomMargin = () => {
    return (props.isTitle || props.headline ? styleVars.rem(1) : 0);
  };

  /** constuct default stylesheet */
  const defaultStyles = StyleSheet.create({
    defaults : {
      fontFamily: 'BoschSansRegular',
      fontSize: defaultFontSize(),
      fontWeight: defaultFontWeight(),
      marginLeft: 0,
      marginTop: 0,
      marginRight: 0,
      marginBottom: defaultBottomMargin(),
    }
  });

  const finalStyles = props.style ? [defaultStyles.defaults, props.style] : [defaultStyles.defaults];
  const numberOfLines = props.numberOfLines ? parseInt(props.numberOfLines,10) : undefined;

  return (
    <Text style={finalStyles} onPress={props.onPress} numberOfLines={numberOfLines} >{props.children}</Text>
  )
}

